module.exports = __webpack_public_path__ + "static/media/siddharth-dosa.5085326e.jpg";